module.exports = __webpack_public_path__ + "img/folder-open-o.709e47db.svg";